const PropTypes = require('prop-types');
const React = require('react');
const ShippingRate = require('./shipping_rates/shipping_rate');
const NewShippingRate = require('./shipping_rates/new_shipping_rate');
const ExpeditedShippingToggle = require('./shipping_rates/expedited_shipping_toggle');
const Loading = require('components/shared/loading');
const UrlHelpers = require('components/shared/url_helpers');
const { reject } = require('lodash');

class ShippingRatesEditor extends React.Component {
  static newShippingRateDefaults(currency) {
    return {
      rate: {
        amount: '',
        currency,
      },
      expeditedRate: {
        amount: '',
        currency,
      },
      incrementalRate: {
        amount: '',
        currency,
      },
      freeShippingThreshold: {
        amount: '',
        currency,
      },
      isValid: false,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      shippingRates: props.shippingRates,
      showNewShippingRate: false,
      newShippingRate: ShippingRatesEditor.newShippingRateDefaults(props.currency),
      isLoaded: false,
      isExpeditedShippingEnabled: this.props.isExpeditedShippingEnabled,
    };

    this.onRemoveShippingRate = this.onRemoveShippingRate.bind(this);
    this.onAddShippingRate = this.onAddShippingRate.bind(this);
    this.onNewShippingRateChange = this.onNewShippingRateChange.bind(this);
    this.showNewShippingRate = this.showNewShippingRate.bind(this);
    this.onExpeditedShippingChange = this.onExpeditedShippingChange.bind(this);
  }

  componentDidMount() {
    this.fetchShippingRegions();
  }

  onNewShippingRateChange(attributes) {
    const newShippingRate = Object.assign({}, this.state.newShippingRate, attributes);
    newShippingRate.isValid = !!newShippingRate.regionCode;

    this.setState({ newShippingRate });
  }

  onAddShippingRate(event) {
    event.preventDefault();

    if (!this.state.newShippingRate.isValid) {
      return;
    }

    const shippingRates = this.state.shippingRates.slice(0);
    const newShippingRate = Object.assign({}, this.state.newShippingRate);
    shippingRates.push(newShippingRate);

    this.setState({
      shippingRates,
      newShippingRate: ShippingRatesEditor.newShippingRateDefaults(this.props.currency),
    });
  }

  onRemoveShippingRate(shippingRateToRemove) {
    const shippingRates = reject(this.state.shippingRates, shippingRate =>
      shippingRate.regionType === shippingRateToRemove.regionType &&
        shippingRate.regionCode === shippingRateToRemove.regionCode);

    this.setState({ shippingRates });
  }

  onExpeditedShippingChange(isExpeditedShippingEnabled) {
    this.setState({ isExpeditedShippingEnabled });
  }

  showNewShippingRate() {
    this.setState({ showNewShippingRate: true });
  }

  fetchShippingRegions() {
    Reverb.APIRequest.V3.get(UrlHelpers.shippingRegionsPath).done((response) => {
      this.setState({
        shippingRegions: response.shipping_regions,
        isLoaded: true,
      });
    });
  }

  renderShippingRates() {
    return this.state.shippingRates.map(shippingRate =>
      (
        <ShippingRate
          key={shippingRate.regionCode}
          fieldsPrefix={this.props.fieldsPrefix}
          showExpeditedFields={this.state.isExpeditedShippingEnabled}
          showIncrementalFields={this.props.showIncrementalFields}
          showFreeShippingThresholdFields={this.props.showFreeShippingThresholdFields}
          shippingRate={shippingRate}
          onRemoveShippingRate={this.onRemoveShippingRate}
        />
      ));
  }

  renderNewShippingRate() {
    if (this.state.showNewShippingRate) {
      return (
        <NewShippingRate
          shippingRegions={this.state.shippingRegions}
          shippingRates={this.state.shippingRates}
          showExpeditedFields={this.state.isExpeditedShippingEnabled}
          showIncrementalFields={this.props.showIncrementalFields}
          showFreeShippingThresholdFields={this.props.showFreeShippingThresholdFields}
          fieldsPrefix={this.props.fieldsPrefix}
          onNewShippingRateChange={this.onNewShippingRateChange}
          onAddShippingRate={this.onAddShippingRate}
          newShippingRate={this.state.newShippingRate}
        />
      );
    }

    return (
      <tr>
        <td colSpan="4">
          <button
            className="button-as-link pull-right"
            onClick={this.showNewShippingRate}
            data-add-shipping-locations
          >
            <span className="fa fa-plus-circle mr-space" />
            {I18n.t('shippingRates.addShippingLocations')}
          </button>
        </td>
      </tr>
    );
  }

  renderExpeditedShippingToggle() {
    if (!this.props.showExpeditedFields) {
      return false;
    }

    return (
      <ExpeditedShippingToggle
        fieldsPrefix={this.props.fieldsPrefix}
        isEnabled={this.state.isExpeditedShippingEnabled}
        canToggle={this.props.canToggleExpeditedShipping}
        onChange={this.onExpeditedShippingChange}
      />
    );
  }

  render() {
    return (
      <Loading loaded={this.state.isLoaded}>
        {this.renderExpeditedShippingToggle()}
        <div className="shipping-input">
          <table className="table margined-bottom">
            <thead>
              <tr className="shipping-rates-header">
                <th>{I18n.t('shippingRates.rateFields.locationColumnHeader')}</th>
                <th className="shipping-rate-cost">
                  {I18n.t('shippingRates.rateFields.costHeader')}
                </th>
                <th className="shipping-rate-action" />
              </tr>
            </thead>
            <tbody>
              {this.renderShippingRates()}
              {this.renderNewShippingRate()}
            </tbody>
          </table>
        </div>
      </Loading>
    );
  }
}

ShippingRatesEditor.propTypes = {
  fieldsPrefix: PropTypes.string.isRequired,
  showIncrementalFields: PropTypes.bool.isRequired,
  showExpeditedFields: PropTypes.bool.isRequired,
  shippingRates: PropTypes.array,
  currency: PropTypes.string.isRequired,
  canToggleExpeditedShipping: PropTypes.bool.isRequired,
  isExpeditedShippingEnabled: PropTypes.bool.isRequired,
  showFreeShippingThresholdFields: PropTypes.bool.isRequired,
};

module.exports = ShippingRatesEditor;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates_editor.jsx